import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from 'app/auth/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if ([401, 403].indexOf(err.status) !== -1) {
          // Only handle if it is not the login request
          if (!request.url.includes('auth/login')) {
            localStorage.removeItem('b2b_token');
            localStorage.removeItem('b2b_user_data');
            localStorage.removeItem('b2b_username');
            localStorage.removeItem('b2b_exp');
            localStorage.removeItem('b2b_role');

            if (err.status === 401) {
              this._router.navigate(['/login']);
            } else {
              this._router.navigate(['/pages/miscellaneous/error']);
            }
          }
        }
        // throwError
        const error = err?.error?.message || err?.statusText || err;
        return throwError(error);
      })
    );
  }
}
